import mermaid from 'mermaid'

import {
  initInternalNavigation,
  initMobileNav,
  listenToEscapeEvent,
} from './navigation'
import { initNewsletterTranslations } from './newsletter'
import initSearch from './search'
import { initSharing } from './sharing'

// import { initVideoChapterPlayback } from './youtube-playback.js'

initMobileNav()
initInternalNavigation()
// initVideoChapterPlayback()
initSharing()
initNewsletterTranslations()
initSearch()
listenToEscapeEvent()

mermaid.initialize({ startOnLoad: true })
